import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, PrimaryButton, Reveal, SectionTag } from "@/components/ui-bits";
import api from "@/lib/api";

const Industries = () => {
  const [industries, setIndustries] = useState([]);

  useEffect(() => {
    api.get("/industries").then((r) => setIndustries(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <PageHero
        eyebrow="Industries"
        lines={["Engineering That Speaks", "Your Industry's Language."]}
        sub="TARK applies cloud, DevOps, data & AI and software engineering to the specific constraints and opportunities of your sector."
      />
      <section className="mx-auto max-w-7xl px-6 pb-28 lg:px-10" data-testid="industries-grid">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {industries.map((ind, i) => (
            <Reveal key={ind.slug} delay={(i % 4) * 0.06}>
              <Link
                to={`/industries/${ind.slug}`}
                data-testid={`industry-card-${ind.slug}`}
                className="card-glow group flex h-full flex-col rounded-2xl border border-tark-line bg-tark-card p-7"
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono text-[11px] text-tark-dim">{String(i + 1).padStart(2, "0")}</span>
                  <ArrowUpRight className="h-4 w-4 text-tark-dim transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-tark-cyan" />
                </div>
                <h3 className="mt-8 font-display text-lg font-bold leading-snug tracking-tight group-hover:text-tark-cyan">{ind.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-tark-mut">{ind.headline}</p>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-20 rounded-2xl border border-tark-line bg-tark-surface/60 p-10 text-center sm:p-14">
          <SectionTag>Your industry, your constraints</SectionTag>
          <h2 className="mt-4 font-display text-2xl font-bold sm:text-3xl">Talk to an Expert</h2>
          <p className="mx-auto mt-4 max-w-xl text-sm text-tark-mut">
            Every sector has its own regulatory, scale and integration realities. Let us map TARK&apos;s engineering capabilities to yours.
          </p>
          <div className="mt-8">
            <PrimaryButton to="/start-a-project" testId="industries-page-cta">Request Consultation</PrimaryButton>
          </div>
        </Reveal>
      </section>
    </>
  );
};

export default Industries;
